<script>import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const SportsSidebarIcon = getIcon("SportsSidebarIcon");
export let size = 27;
export let active = false;
export let hover = false;
export let color = void 0;
</script>

{#if typeof SportsSidebarIcon === 'string'}
	<img src={SportsSidebarIcon} alt={$t(Verbiage.sports_icon_alt, 'alts')} />
{:else if typeof SportsSidebarIcon === 'function'}
	<svelte:component this={SportsSidebarIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
